import { render, staticRenderFns } from "./miniCard.vue?vue&type=template&id=12427f21"
import script from "./miniCard.vue?vue&type=script&lang=js"
export * from "./miniCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports